import { Alert, Button } from 'antd';
import i18next from 'i18next';
import { Component, ErrorInfo, ReactNode } from 'react';

/**
 * Keeps one failing view from blanking the whole app (audit finding F17: a piece crashed the page to white); the
 * message names the view and the error, and the view can be tried again.
 */
export default class ErrorBoundary extends Component<
  { children: ReactNode; name: string; resetKey?: unknown },
  { error: Error | undefined }
> {
  state = { error: undefined as Error | undefined };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(`${this.props.name} failed`, error, info.componentStack);
  }

  componentDidUpdate(previous: { resetKey?: unknown }) {
    // A different piece is a fresh start for the view.
    if (this.state.error && previous.resetKey !== this.props.resetKey)
      this.setState({ error: undefined });
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <Alert
        action={
          <Button onClick={() => this.setState({ error: undefined })} size="small">
            {i18next.t('errorBoundary.retry')}
          </Button>
        }
        description={this.state.error.message}
        title={i18next.t('errorBoundary.title', { name: this.props.name })}
        showIcon
        type="error"
      />
    );
  }
}
